"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrevMonth;

var _moment = _interopRequireDefault(require("moment"));

var _isSameMonth = _interopRequireDefault(require("./isSameMonth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isPrevMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/isPrevMonth.js
 ** module id = 1826
 ** module chunks = 0
 **/